export default __webpack_public_path__ + "static/media/logo.2432014a.svg";